const containerId = { app: 'loyalty-app', widget: 'loyalty-widget' };
export default containerId;
